import React from 'react';

// StudyTimer Component - Extracted from App.js for better maintainability
// Handles study session timing with start, pause, reset functionality

const StudyTimer = ({ 
  studyTime, 
  isStudying, 
  formatTime, 
  getCurrentStudyTime, 
  startStudySession, 
  pauseStudySession, 
  resetStudySession 
}) => {
  return (
    <div className="mb-6 p-4 bg-gradient-to-r from-green-50 to-blue-50 rounded-lg">
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-semibold text-gray-800">Study Session</h3>
        <div className="flex items-center space-x-2">
          <span className={`inline-block w-2 h-2 rounded-full ${isStudying ? 'bg-green-500 animate-pulse' : 'bg-gray-400'}`}></span>
          <span className="text-sm font-medium text-gray-600">
            {isStudying ? 'Active' : 'Paused'}
          </span>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row items-center justify-between mb-3 space-y-2 sm:space-y-0">
        <div className="text-2xl font-bold text-gray-800">
          {formatTime(getCurrentStudyTime())}
        </div>
        <div className="flex space-x-2">
          {!isStudying ? (
            <button
              onClick={startStudySession}
              className="px-3 py-1 bg-green-500 text-white rounded-lg hover:bg-green-600 transition-colors text-sm"
              title="Start studying"
            >
              ▶ Start
            </button>
          ) : (
            <button
              onClick={pauseStudySession}
              className="px-3 py-1 bg-yellow-500 text-white rounded-lg hover:bg-yellow-600 transition-colors text-sm"
              title="Pause studying"
            >
              ⏸ Pause
            </button>
          )}
          <button
            onClick={resetStudySession}
            className="px-3 py-1 bg-gray-500 text-white rounded-lg hover:bg-gray-600 transition-colors text-sm"
            title="Reset timer"
          >
            🔄 Reset
          </button>
        </div>
      </div>
      <div className="text-xs text-gray-500">
        {studyTime > 0 && !isStudying && 'Session paused'} 
        {isStudying && 'Keep going! 💪'}
        {studyTime === 0 && !isStudying && 'Ready to start studying'}
      </div>
    </div>
  );
};

export default React.memo(StudyTimer);